/** Limites courantes pour l’extrait desktop Google (approximation SEO). */
export const SERP_TITLE_MAX_CHARS = 60;
export const SERP_DESC_MAX_CHARS = 160;

export function truncateSerpText(text, maxChars) {
  if (!text || typeof text !== 'string') return '';
  const t = text.trim();
  if (t.length <= maxChars) return t;
  return `${t.slice(0, maxChars - 1).trimEnd()}…`;
}

export function serpFaviconUrl(url) {
  if (!url) return null;
  try {
    const href = /^https?:\/\//i.test(url) ? url : `https://${url}`;
    const host = new URL(href).hostname;
    return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(host)}&sz=128`;
  } catch {
    return null;
  }
}

/**
 * Ligne d’affichage type Google : favicon + nom de site + fil d’Ariane.
 */
export function serpBreadcrumb(url) {
  if (!url || typeof url !== 'string') return { site: '', path: '', favicon: null };
  try {
    const href = /^https?:\/\//i.test(url) ? url : `https://${url}`;
    const u = new URL(href);
    const site = u.hostname;
    const segments = u.pathname.replace(/\/$/, '').split('/').filter(Boolean);
    const path = segments.length > 0 ? segments.join(' › ') : '';
    return { site, path, favicon: serpFaviconUrl(href) };
  } catch {
    const clean = url.replace(/^https?:\/\//, '');
    const [host, ...rest] = clean.split('/');
    return {
      site: host || clean,
      path: rest.filter(Boolean).join(' › '),
      favicon: serpFaviconUrl(url),
    };
  }
}
